module.exports = (original)-> ({React,FormGroup})->
  (props)->    
    {id,country,region,type,presenter,reference} = props.data
    extrafields = [
      <FormGroup label="Country" key="country">
        <input type="text" className="form-control" id="Country" placeholder="Country" value={country || ""} onChange={(e)=> props.onUpdate(id,"country",e.target.value)} />
      </FormGroup>
      <FormGroup label="Region" key="region">
        <input type="text" className="form-control" id="region" placeholder="Region" value={region || ""} onChange={(e)=> props.onUpdate(id,"region",e.target.value)} />
      </FormGroup>
      <FormGroup label="Type" key="type">
        <input type="text" className="form-control" id="type" placeholder="Type" value={type || ""} onChange={(e)=> props.onUpdate(id,"type",e.target.value)} />
      </FormGroup>
      <FormGroup label="Presenter" key="type">
        <input type="text" className="form-control" id="presenter" placeholder="Presenter" value={presenter || ""} onChange={(e)=> props.onUpdate(id,"presenter",e.target.value)} />
      </FormGroup>
      <FormGroup label="Salesforce Id" key="reference">
        <input type="text" className="form-control" id="reference" value={reference || "" } readOnly onChange={(e)=> props.onUpdate(id,"reference",e.target.value)} />
      </FormGroup>

      <div className="row" key="notice">{if reference?
        <div className="col-sm-9 col-sm-offset-3">
          <div className="alert alert-info">
            Please make any changes to this event in Salesforce.
          </div>
        </div>
      }</div>
      
    ]
    originalfields = original(props)
    offset = originalfields.length-1
    originalfields[...offset].concat extrafields,originalfields[offset...]